package com.tovtalk.domain.entity

data class FollowPreferences(
    val notifyNewPosts: Boolean = true,
    val notifyNewStories: Boolean = true,
    val notifyLive: Boolean = true
)
